import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconChevronLeft: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10 4L6 8L10 12"
    />
  </svg>
);

export {
  IconChevronLeft,
};
